import {
  TAKING_CAR_PURCHASE_GET_DATA_TABS_BEGIN,
  TAKING_CAR_PURCHASE_GET_DATA_TABS_SUCCESS,
  TAKING_CAR_PURCHASE_GET_DATA_TABS_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case TAKING_CAR_PURCHASE_GET_DATA_TABS_BEGIN:
      return {
        takingCarManagement: {
          ...state.takingCarManagement
        }
      }
    case TAKING_CAR_PURCHASE_GET_DATA_TABS_SUCCESS:

      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          dataTabs: action.data
        }
      }
    case TAKING_CAR_PURCHASE_GET_DATA_TABS_FAILURE:
      return {
        takingCarManagement: {
          ...state.takingCarManagement
        }
      }
    default:
      return state
  }
}
